export default function Footer() {
  return (
    <div className="Footer">
      <p>
        This app was coded by Suzanna Wallis and is open-sourced on{" "}
        <a href="https://github.com/SuzannaW-web/weather-react-app">GitHub </a>
        and{" "}
        <a href="https://react-weather-by-suzanna.netlify.app/">
          hosted on Netlify
        </a>
      </p>
    </div>
  );
}
